var Iframe_default = {
  "iframe": "hkhXB"
};
export {
  Iframe_default as default
};
//# sourceMappingURL=Iframe-scss.js.map
